var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.995 0v8.176L3.75 4.93 2.336 6.345 7.99 12l.002-.002.002.002 5.665-5.664-1.414-1.415-3.25 3.25V0h-2zM2 12H0v4h16v-4h-2v2H2v-2z",
    fill: "currentColor"
  })));
};
export { SvgDownload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuOTk1IDB2OC4xNzZMMy43NSA0LjkzIDIuMzM2IDYuMzQ1IDcuOTkgMTJsLjAwMi0uMDAyLjAwMi4wMDIgNS42NjUtNS42NjQtMS40MTQtMS40MTUtMy4yNSAzLjI1VjBoLTJ6TTIgMTJIMHY0aDE2di00aC0ydjJIMnYtMnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";